<template>
  <div class="space-indicator">
    <div
      v-if="isSpaceLeft"
      class="space-indicator__body">
      <span class="el-text el-text--subheading">
        {{ $t('wrh-dashboard.space-indicator.label.left', storageSpaceUsageInfo) }}
      </span>
      <el-progress
        :percentage="wormStatus.spaceUsedPercent"
        :color="wormStatus.progressColor"/>
    </div>
    <div
      v-if="isSpaceUsed"
      class="space-indicator__body">
      <!--<el-icon slot="icon" name="i-infinity&#45;&#45;32"/>&nbsp;-->
      <span class="el-text el-text--subheading">
        {{ $t('wrh-dashboard.space-indicator.label.used', storageSpaceUsageInfo) }}
      </span>
      <div class="el-text el-text--body-24">
        {{ $t('wrh-dashboard.space-indicator.label.unlimited') }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpaceIndicator',
  props: {
    used: {
      type: Number,
      default: 0,
      required: true
    },
    total: {
      type: Number,
      default: 0,
      required: true
    },
    indicatorType: {
      type: String,
      default: 'SPACE_LEFT',
      required: false,
      validator: value => value === 'SPACE_LEFT' || value === 'SPACE_USED'
    }
  },
  computed: {
    storageSpaceUsageInfo() {
      return {
        usedSpace: this.$options.filters.size(Math.max(this.used, 0)),
        totalSpace: this.$options.filters.size(Math.max(this.total, 0)),
        spaceFree: this.$options.filters.size(Math.max(this.total - this.used, 0))
      };
    },
    isSpaceLeft() {
      return this.indicatorType === 'SPACE_LEFT';
    },
    wormStatus() {
      let progressColor;

      let spaceUsedPercent = 0;
      let spaceUsedPercentFp = 0.0;

      if (this.total > 0) {
        spaceUsedPercentFp = (this.used / this.total) * 100;
        spaceUsedPercent = Math.min(Math.max(Math.floor(spaceUsedPercentFp), 0), 100);
      }

      const freeSpace = 100.0 - spaceUsedPercentFp;

      if (freeSpace <= 0.0) {
        progressColor = 'fixed-danger';
      } else if (freeSpace > 0.0 && freeSpace < 1.0) {
        progressColor = 'fixed-warning';
      } else if (freeSpace >= 1.0 && freeSpace < 10.0) {
        progressColor = 'fixed-warning';
      } else if (freeSpace >= 10.0 && freeSpace < 30.0) {
        progressColor = 'fixed-warning';
      } else if (freeSpace >= 30.0) {
        progressColor = 'fixed-success-lighter';
      }

      return {
        progressColor: progressColor,
        spaceUsedPercent: spaceUsedPercent
      };
    },
    isSpaceUsed() {
      return this.indicatorType === 'SPACE_USED';
    },
    spaceUsed() {
      return Math.max(this.used, 0);
    }
  }
};
</script>

<style lang="scss" scoped>
  .space-indicator {
    color: $av-nav-text;
  }
  .space-indicator__body {
    width: 100%;
  }
</style>
